module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("kpuKN"))).then(() => parcelRequire('d0iPb'));